import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

/**
 * IMAGE AND CONTENT SLIDER STANDALONE MODULE
 */
export namespace ContentAndMediaSlider {
    let SetupSlider = () => {
        let contentAndMediaSliders = document.querySelectorAll('.js-content-and-media-slider');

        /**
         * Setup each instance of the image and content slider
         */
        contentAndMediaSliders.forEach((slider, index) => {
            let parent = slider.closest('.content-and-media-slider__wrapper');
            let navigation = parent.querySelector('.content-and-media-slider__navigation');
            let counter = parent.querySelector('.content-and-media-slider__counter');
            parent.classList.add(`content-and-media-slider__wrapper-${index}`);
            navigation.classList.add(`content-and-media-slider__navigation-${index}`);
            counter.classList.add(`content-and-media-slider__counter-${index}`);
            slider.classList.add('content-and-media-slider-' + index);
            let fpSliderList = [];
            let counterContainer = document.querySelector(`.content-and-media-slider__counter-${index}`);

            let fpSlider = new Swiper(`.content-and-media-slider-${index}`, {
                slidesPerView: 1,
                speed: 400,
                spaceBetween: 0,
                centeredSlides: true,
                loop: false,
                simulateTouch: true,

                navigation: {
                    nextEl: `.content-and-media-slider__navigation-${index} .swiper-button-next`,
                    prevEl: `.content-and-media-slider__navigation-${index} .swiper-button-prev`,
                },

                on: {
                    init: function (swiper) {
                        if (swiper.slides.length > 1) {
                            counterContainer.textContent = `${swiper.activeIndex + 1}/${swiper.slides.length}`;
                        }
                    },
                    slideChange: function (swiper) {
                        if (swiper.slides.length > 1) {
                            counterContainer.textContent = `${swiper.activeIndex + 1}/${swiper.slides.length}`;
                        }
                    },
                },
            });

            fpSliderList.push(fpSlider);
            fpSlider.init();
        });
    };
    export const init = () => {
        SetupSlider();
    };
}

/**
 * DOMContentLoaded may fire before script has a chance to run, so it is wise to check before adding
 */
if (document.readyState === 'loading') {
    // Loading hasn't finished yet
    document.addEventListener('DOMContentLoaded', ContentAndMediaSlider.init);
} else {
    // `DOMContentLoaded` has already fired
    ContentAndMediaSlider.init();
}
